import React from 'react';
export default function BowTieSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="8,14 20,20 8,26" fill="#E53935" />
      <polygon points="32,14 20,20 32,26" fill="#E53935" />
      <circle cx="20" cy="20" r="3" fill="#B71C1C" />
      <circle cx="20" cy="20" r="1.5" fill="#FFCDD2" />
    </svg>
  );
}
